import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import momentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, Calendar } from '@material-ui/pickers';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { FiberManualRecord } from '@material-ui/icons';
import {
  Badge, Grid,
} from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import ScreenLoader from 'components/organismos/ScreenLoader';
import '../style.css';
import Triangle from 'components/atoms/Icons/Triangle';
import { IBookingOnlineState } from '../type';

class LocalizedUtils extends momentUtils {
  // eslint-disable-next-line class-methods-use-this
  getCalendarHeaderText(date: moment.MomentInput) {
    return moment(date).format('YYYY年M月');
  }
}
function CustomCalendar({
  disabledLastDay, possibleDayCode, selectedDate, handleDateChange, handleMonthChange, isShowFullyCalender, loading, publicDays, selectedDays, selectedCallDays, handleUpdateCalendar, courseCategory, desiredCourse, orgId, courseTime, disabledFutureCalendar = false, stateReducer, companyCode,
}:{
    selectedDate:moment.Moment,
    handleDateChange:(date: moment.Moment | null)=>void,
    handleMonthChange:(date: moment.Moment | null)=>void,
    isShowFullyCalender:boolean,
    loading:boolean,
    selectedDays:number[],
    selectedCallDays:number[],
    publicDays:number[],
    handleUpdateCalendar:()=>void,
    courseCategory:string,
    desiredCourse:string,
    orgId:string,
    courseTime:string,
    disabledFutureCalendar:boolean,
    possibleDayCode:string,
    disabledLastDay:boolean,
    stateReducer:IBookingOnlineState,
    companyCode:string,
}) {
  const myRefCalender = useRef<any>(null);
  const disabledDays = (date: moment.Moment | null) => {
    if (!isShowFullyCalender) {
      return false;
    }
    return publicDays.concat(selectedCallDays).includes(Number(moment(date).format('DD')));
  };
  const theme = createMuiTheme({
    palette: {
      primary: { light: green[300], main: green[500], dark: green[700] },
    },
    overrides: {
      MuiBadge: {
        anchorOriginTopRightRectangle: {
          bottom: '5px',
          top: 'unset',
          right: 'unset',
          transform: 'unset',
        },
      },
      MuiButtonBase: {
        root: {
          background: '#D8E3C0',
        },
      },
    },
  });
  function renderColor(isSelected:boolean, day: moment.Moment | null) {
    if (moment(day).day() === 6) {
      return 'blueGrid';
    }

    if (moment(day).day() === 0) {
      return 'redGrid';
    }
    // check is in private Holidays
    for (const element of [...stateReducer.privateHolidays]) {
      const startDate = moment(element.timeFrom).format('YYYY-MM-DD');
      const endDate = moment(element.timeTo).format('YYYY-MM-DD');
      if (moment(startDate).isSame(day) || moment(endDate).isSame(day) || moment(day).isBetween(startDate, endDate)) { return 'normalGrod'; }
    }

    if (stateReducer.publicHolidayList.length > 0) {
      for (const holiday of stateReducer.publicHolidayList) {
        const dayTemp = +moment(holiday.date).format('DD');
        if (Number(moment(day).format('DD')) === dayTemp) {
          return 'redGrid';
        }
      }
    }
    return 'normalGrod';
  }
  const showHiddenNextButton = () => {
    if (disabledFutureCalendar) {
      return {
        opacity: 0,
      };
    }
    return {
      opacity: 1,
    };
  };
  const showHiddenPreviosButton = () => {
    if (disabledLastDay) {
      return {
        opacity: 0,
      };
    }
    return {
      opacity: 1,
    };
  };
  // const renderColorDay =()=>{

  // }
  const renderText = (date: moment.Moment | null) => {
    // check is in private Holidays
    for (const element of [...stateReducer.privateHolidays]) {
      const startDate = moment(element.timeFrom).format('YYYY-MM-DD');
      const endDate = moment(element.timeTo).format('YYYY-MM-DD');
      if (moment(startDate).isSame(date) || moment(endDate).isSame(date) || moment(date).isBetween(startDate, endDate)) { return '休'; }
    }
    if (stateReducer.publicHolidayList.length > 0) {
      for (const holiday of stateReducer.publicHolidayList) {
        const day = +moment(holiday.date).format('DD');
        if (Number(moment(date).format('DD')) === day) {
          return (stateReducer?.publicHoliday ? '休' : '');
        }
      }
    }
    if (moment(date).day() === 1 && stateReducer.regularHolidayMonday) {
      return '休';
    }
    if (moment(date).day() === 2 && stateReducer.regularHolidayTuesday) {
      return '休';
    }
    if (moment(date).day() === 3 && stateReducer.regularHolidayWednesday) {
      return '休';
    }
    if (moment(date).day() === 4 && stateReducer.regularHolidayThursday) {
      return '休';
    }
    if (moment(date).day() === 5 && stateReducer.regularHolidayFriday) {
      return '休';
    }
    if (moment(date).day() === 6 && stateReducer.regularHolidaySaturday) {
      return '休';
    }
    if (moment(date).day() === 0 && stateReducer.regularHolidaySunday) {
      return '休';
    }
    return '';
  };
  const maxDate = moment(new Date(selectedDate.toString()).setDate(+possibleDayCode));
  moment.locale('ja');
  useEffect(() => {
    let render = true;
    if (isShowFullyCalender && render) {
      handleUpdateCalendar();
    }
    return () => {
      render = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowFullyCalender, courseCategory, desiredCourse, orgId, courseTime]);
  return (
    <div className="reservationPage" style={{ padding: '16px 0' }}>
      <ScreenLoader isLoading={loading}>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider libInstance={moment} utils={LocalizedUtils} locale="ja">

            <div
              style={{
                maxWidth: '695px', overflow: 'hidden',
              }}
              ref={myRefCalender}
            >
              <Calendar
                rightArrowButtonProps={{
                  style: showHiddenNextButton(),
                }}
                leftArrowButtonProps={{
                  style: showHiddenPreviosButton(),
                }}
                disablePast={true}
                maxDate={disabledFutureCalendar ? maxDate : undefined}
                date={selectedDate}
                onChange={handleDateChange}
                onMonthChange={handleMonthChange}
                shouldDisableDate={disabledDays || false} // eslint-disable-next-line @typescript-eslint/no-shadow
                allowKeyboardControl={false}
                renderDay={(day, selectedDateCalendar, dayInCurrentMonth, dayComponent) => {
                // const { selectedDays, selectedCallDays, publicDays } = tempState;
                  if (!isShowFullyCalender) {
                    return (
                      <Badge
                        style={{
                          opacity: dayComponent ? 1 : 0,
                          width: '100px',
                          height: '85px',
                          border: '1px solid #cccccc',
                          justifyContent: 'center',
                          marginRight: '-1px',
                          marginTop: '-1px',
                          maxWidth: `${myRefCalender?.current && (myRefCalender?.current?.clientWidth + 6) / 7 < 100 ? `${(myRefCalender?.current?.clientWidth + 6) / 7}px` : '100px'}`,
                        }}
                      >
                        <Grid item={true}>
                          {dayComponent}
                        </Grid>
                      </Badge>
                    );
                  }
                  const isSelected = dayInCurrentMonth && selectedDays.includes(day?.toDate().getDate() || 0);
                  const isSelectedCall = dayInCurrentMonth && selectedCallDays.includes(day?.toDate().getDate() || 0);
                  const isPublicDay = dayInCurrentMonth && publicDays.includes(day?.toDate().getDate() || 0);
                  const colorString = renderColor(isSelected, day);
                  return (
                    <Badge
                      style={{
                        opacity: dayComponent ? 1 : 0,
                        maxWidth: '100px',
                        height: '85px',
                        border: '1px solid #cccccc',
                        justifyContent: 'center',
                        marginRight: '-1px',
                        marginTop: '-1px',
                        pointerEvents: 'all',
                        minWidth: `${myRefCalender?.current && (myRefCalender?.current?.clientWidth + 6) / 7 < 100 ? `${(myRefCalender?.current?.clientWidth + 6) / 7}px` : '100px'}`,
                      }}
                      // eslint-disable-next-line no-nested-ternary
                      badgeContent={isPublicDay ? renderText(day) : (isSelected ? <FiberManualRecord fontSize="small" /> : (isSelectedCall ? (
                        // eslint-disable-next-line jsx-a11y/control-has-associated-label
                        companyCode === 'ci_zlabo' ? <a href="https://www.ci-z.com/form3/" target="_blank"><Triangle /></a> : <Triangle />
                      ) : undefined))}
                    >
                      <Grid
                        item={true}
                        className={`${colorString}`}
                      >
                        {dayComponent}
                      </Grid>
                    </Badge>
                  );
                }}
              />
            </div>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
        <Grid container={true} direction="row" justify="flex-end" alignItems="center" style={{ marginTop: '25px' }}>
          <FiberManualRecord fontSize="small" />
          {' '}
          予約可能 /
          {' '}
          <div style={{ margin: '0 3px' }}><Triangle /></div>
          {' '}
          クリックして問合せフォームよりご連絡ください。
        </Grid>
      </ScreenLoader>
    </div>
  );
}

export default React.memo(CustomCalendar);
